import angular from 'angular';
import ngRoute from 'angular-route';
import configuracionService from './configuracion.service';

import { SliderComponent } from './sliders/sliders.component';
import { DestacadosComponent } from './destacados/destacados.component';
import { OfertasComponent } from './ofertas/ofertas.component';

/*@ngInject*/
const configuracionRoutes = function ($routeProvider) {
    $routeProvider
        .when('/configuracion/slider', {
            template: '<editar-slider slides="$resolve.slides.data.slides" categorias="$resolve.slides.data.categorias"></editar-slider>',
            authenticate: true,
            administrator: true,
            resolve: {
                slides: getSlides
            }
        })
        .when('/configuracion/ofertas', {
            template: '<editar-ofertas ofertas="$resolve.ofertas.data.ofertas" categorias="$resolve.ofertas.data.categorias"></editar-ofertas>',
            authenticate: true,
            administrator: true,
            resolve: {
                ofertas: getOfertas
            }
        })
        .when('/configuracion/destacados', {
            template: '<editar-destacados destacados="$resolve.destacados.data.destacados"></editar-destacados>',
            authenticate: true,
            administrator: true,
            resolve: {
                destacados: getDestacados
            }
        });
    
    function getSlides(ConfiguracionService){
        return ConfiguracionService.getSlides();
    }

    function getOfertas(ConfiguracionService){
        return ConfiguracionService.getOfertas();
    }

   function getDestacados(ConfiguracionService){
        return ConfiguracionService.getDestacados();
    }

};

export default angular.module('pizzuto-autopartes.configuracion', [ngRoute])
    .config(configuracionRoutes)
    .service('ConfiguracionService', configuracionService)
    .component(SliderComponent.selector, SliderComponent)
    .component(DestacadosComponent.selector, DestacadosComponent)
    .component(OfertasComponent.selector, OfertasComponent)
    .name;



// WEBPACK FOOTER //
// ./client/app/configuracion-route/index.js